import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=db3484ee&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=js&"
export * from "./Cards.vue?vue&type=script&lang=js&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=db3484ee&scoped=true&lang=scss&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=db3484ee&scoped=true&lang=css&"
import style2 from "./Cards.vue?vue&type=style&index=2&id=db3484ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3484ee",
  null
  
)

export default component.exports